import { render, staticRenderFns } from "./ScListView.vue?vue&type=template&id=3b0e82d0&scoped=true&"
import script from "./ScListView.vue?vue&type=script&lang=js&"
export * from "./ScListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e82d0",
  null
  
)

export default component.exports